<div class="bookings">
  <div class="section-title">
    <!--
    <h3> Réservations {{ car.make}} {{ car.model}}, {{ car.year}}  ({{bookings!.length}})</h3>
    <app-booking-edit
      [carId]="car.id"
      [bookings]="car.bookings">
    </app-booking-edit> -->

    @if (enableNew) {
      <button mat-button class="cta-button-buy"  mat-button (click)="openBookingDialog(0);$event.stopPropagation()">
        Nouvelle<mat-icon>add</mat-icon>
      </button>
    }

  </div>

  @if (bookings == undefined || bookings.length === 0) {
    <span>
      Aucune reservation en cours
    </span>
  }

  @if (!(bookings == undefined || bookings.length === 0 )) {
    <div class="booking-list">
      @for (booking of bookings; track booking; let i = $index) {
        <div class="booking">
          <div class="summary">
            <!-- <b>[{{ (conversation.participants[0] === null)? 'EXT' : conversation.participants[0] }}]</b> -->
            @if (objectSource===ObjectSource.DEALER) {
              <h4> {{booking.carInfoSummary}}</h4>
            }
            <h5 class="summary-details"><mat-icon>forum</mat-icon> N° {{booking.id}} - {{booking.paymentTermOption}} </h5>
            <h6 class="summary-details"><mat-icon>person</mat-icon> Client: <b>{{booking.customerName }}</b></h6>
            <!-- <h6 class="summary-details"><mat-icon>person</mat-icon> Vendeur: <b>{{booking.}} - {{booking.providerBusinessName}}</b></h6> -->
            <h6 class="summary-details"><mat-icon>call</mat-icon>(+{{ booking.driverPhoneNumber.code }}) {{booking.driverPhoneNumber.number}}</h6>
            <h6 class="summary-details"><mat-icon>call</mat-icon>{{booking.withDriver ? "AVEC" : "SANS"}} chauffeur</h6>
          </div>
          <div class="content">
            <h4 >{{ dateFormat(""+booking.startDate) }} - {{ dateFormat(""+booking.endDate )}} ({{ booking.totalDays}}J)</h4>
            <h5 class="status">{{ booking.status }} </h5>
            <h6>Voiture: {{booking.totalDays}}J * {{ moneyFormat(""+booking.carDayRate)}} {{ booking.currency }}/J = {{ moneyFormat(""+booking.carAmount)}} {{ booking.currency }}</h6>
            @if (booking.withDriver) {
              <h6>Chauffeur: {{booking.withDriver ? booking.totalDays : 0}}J * {{ moneyFormat(""+booking.driverDayRate)}} {{ booking.currency }}/J =
              {{ moneyFormat(""+booking.driverAmount)}} {{ booking.currency }}</h6>
            }
            <h6>Assurances: {{booking.totalDays}}J * {{ moneyFormat(""+booking.insuranceDayRate)}} {{ booking.currency }}/J =
            {{ moneyFormat(""+booking.insuranceAmount)}} {{ booking.currency }}</h6>
            <h5>Montant total: <b>{{ moneyFormat(""+booking.totalAmountToPay)}} {{ booking.currency }}</b></h5>
            @if (booking.modification !== null) {
              <span>
                <h5> Modif:</h5>
                <h6 > {{booking.modification!.carDayRate}} {{booking.modification!.currency}}
                  / {{dateFormat(booking.modification!.startDate)}} / {{dateFormat(booking.modification!.endDate)}} / {{booking.modification!.notes}} /
                {{booking.modification!.status}}</h6>
              </span>
            }
            @if (booking.status === BookingStatus.COMPLETED) {
              <span>
                <h5> Vente:</h5>
                <h6> {{booking.completedPrice.amount}} {{booking.completedPrice.currency}}
                / {{dateFormat(booking.completedDate)}} / {{booking.completedNotes}} </h6>
              </span>
            }
            <!--
            <h6> Date création: {{dateFormat(booking.created)}}</h6>
            <h6> Dernière mise a jour: {{dateFormat(booking.lastUpdated)}}</h6>  -->
            <div class="action-buttons">
              @for (actionItem of bookingActionItems; track actionItem; let j = $index) {
                <div>
                  @if (booking.dealerActions?.includes(actionItem.action)) {
                    <button
                      class="simple-button"  mat-button (click)="executeAction(booking, actionItem.action);$event.stopPropagation()">
                      {{ actionItem.title }} <mat-icon> {{ actionItem.icon }}</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
            <!--
            <div class="action-buttons">
              <button *ngIf="(booking.status === BookingStatus.DRAFT)"
                class="simple-button"  mat-button (click)="openBookingDialog(booking.id);$event.stopPropagation()">
                Editer <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="(booking.status === BookingStatus.DRAFT)"
                class="simple-button"  mat-button (click)="updateBookingStatus(booking.id, BookingStatus.COMPLETED);$event.stopPropagation()">
                Soumettre <mat-icon>calendar</mat-icon>
              </button>
              <button *ngIf="(booking.status === BookingStatus.COMPLETED)"
                class="simple-button"  mat-button (click)="updateBookingStatus(booking.id, BookingStatus.CONFIRMED);$event.stopPropagation()">
                Confirmer <mat-icon>accept</mat-icon>
              </button>
              <button *ngIf="(booking.status !== BookingStatus.CANCELLED)"
                class="simple-button"  mat-button (click)="updateBookingStatus(booking.id, BookingStatus.CANCELLED);$event.stopPropagation()">
                Annuler <mat-icon>cancel</mat-icon>
              </button>
            </div>
            -->
          </div>
        </div>
      }
    </div>
  }
</div>


